import { Box, Flex, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import Layout from "../../../components/dashboard/Layout";
import LogoutMenu from "../../../components/dashboard/Layout/logout-menu";
import CTable from "../../../components/Table/table";
import { videoAbsenceReportRequest } from "../../../modules/admin-modules/reports/Actions";
import { getAllVideosRequest } from "../../../modules/admin-modules/videos/Actions";
import { getAllGroupsRequest } from "../../../modules/admin-modules/groups/Actions";

const VideoAbsenceReport = ({ setAdd, setSelectedData, searchTerm }) => {
  const dispatch = useDispatch();
  const videos = useSelector((state) => state.videos.videos);
  const groups = useSelector((state) => state.groups.groups);   
  const videosReport = useSelector((state) => state.reports.videosReport);
  const iaLoading = useSelector((state) => state.reports.iaLoading);
  const [size, setPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [selected, setSelected] = useState({
    id: "",
  });
  const [videoId, setVideoId] = useState("");
  const [groupIds, setGroupIds] = useState([]);

  useEffect(() => {
    if (videoId) {
      dispatch(videoAbsenceReportRequest({
        id: videoId,
        group_id: groupIds.length > 0 ? groupIds : undefined
      }));
    }
  }, [videoId, groupIds]);

  useEffect(() => {
    dispatch(getAllVideosRequest());
    dispatch(getAllGroupsRequest());
  }, []);

  const videosOptions = videos?.map((data) => {
    return { value: data.id, label: data.title };
  });

  const groupsOptions = groups?.map((data) => {
    return { value: data.id, label: data.name };
  })

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "#f5f5f5",
      color: "#690000",
      borderRadius: "16px",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };

  const viewData = (data) => {
    setSelectedData(data);
    setSelected(data);
  };
  const headers = [
    { label: "name", key: "name" },
    { label: "phone", key: "phone" },
    { label: "parent_phone", key: "parent_phone" },
  ];
  const Data = videosReport?.map((data, index) => {
    return {
      ...data,
      index: `#${index + 1}`,
      id: data?.id,
      name: data?.name,
      phone: data?.phone,
      parent_phone: data?.parent_phone,
    };
  });
  const columns = [
    {
      Header: "رقم الطالب",
      accessor: "index",
    },
    {
      Header: "اسم الطالب",
      accessor: "name",
    },
    {
      Header: " رقم ولي الامر ",
      accessor: "parent_phone",
    },
    {
      Header: " رقم  الطالب",
      accessor: "phone",
    },
  ];
  console.log(groupIds)
  return (
    <Layout>
      <div style={{ minHeight: "400px" }}>
        <Flex
          w="100%"
          my="30px"
          justifyContent="space-between"
          alignItems="center"
          position="relative"
          zIndex="100"
        >
          <Text fontSize="24px" fontWeight="600" color="main_1">
            تقرير غياب مشاهدات الفيديوهات
          </Text>
          <Flex w="60%" alignItems="center" gap={2}>
            <Select
              options={videosOptions}
              isMulti={false}
              onChange={(data) => {
                setVideoId(data?.value);
              }}
              styles={colourStyles}
              placeholder="Select Video"
            />

            <Select
              options={groupsOptions}
              isMulti={true}
              onChange={(data) => {
                setGroupIds(data?.map(item => item.value) || []);
              }}
              styles={colourStyles}
              placeholder="Select Groups"
            />

            <Box
              mx="10px"
              border="1px solid gray"
              borderRadius="8px"
              padding="10px"
            >
              <CSVLink
                headers={headers}
                data={Data?.length != 0 ? Data : []}
                filename={"video-views-report.csv"}
                className="btn btn-primary"
                target="_blank"
              >
                Download
              </CSVLink>
            </Box>
            <LogoutMenu />
          </Flex>
        </Flex>

        <CTable
          selectedData={viewData}
          Columns={columns}
          Data={Data}
          path={"openModel"}
          Actions
          Title={``}
          subTitle=""
          btnTitle=""
          placeHolder=""
          noSearchBar={true}
          noFilter={true}
          footerBtnTitle
          filterList
          addButton
          addButtonTitle=""
          setPage={() => {}}
          setPerPage={setPerPage}
          currentpage={pageNumber}
          setPageNumber={setPageNumber}
          noSecondSearchBar={true}
          isLoading={iaLoading}
          perPage={size}
          totalPage={Math.ceil(10 / 50)}
        />
      </div>
    </Layout>
  );
};

export default VideoAbsenceReport;
